/* Date guard for cached pages and pages left open across the offer boundary. */
(() => {
  const start=Date.parse('2026-11-04T00:00:00-05:00');
  const end=Date.parse('2026-11-14T00:00:00-05:00');
  if(document.currentScript?.dataset.bwGiftDesignPreview==='true')return;
  const expired=()=>Date.now()<start||Date.now()>=end;
  const selectors='[data-bw-gift-offer],[data-bw-gift-offer-compact],[data-bw-gift-offer-card],.bw-pending-reward';
  const hide=()=>{
    if(!expired())return;
    document.querySelectorAll(selectors).forEach(el=>{el.hidden=true;el.style.display='none'});
    document.querySelectorAll('[data-bw-gift-offer-active]').forEach(root=>{
      root.removeAttribute('data-bw-gift-offer-active');
      const offer=root.querySelector('.bw-gift-offer-slot');
      if(offer){offer.hidden=true;offer.removeAttribute('id')}
      root.querySelectorAll('.bw-gift-offer-original').forEach(el=>{el.hidden=false;el.inert=false;el.classList.remove('bw-gift-offer-original')});
      const original=root.querySelector('#bw-original-package');
      if(original)original.id='package';
      const nav=root.querySelector('.section-nav a[href="#package"]');
      if(nav)nav.textContent='Build your package';
    });
    document.querySelectorAll('[data-bw-gift-bundle-add]').forEach(el=>{el.disabled=true});
  };
  document.addEventListener('click',event=>{
    if(expired()&&event.target.closest('[data-bw-gift-bundle-add]')){event.preventDefault();event.stopImmediatePropagation();hide()}
  },true);
  hide();
  new MutationObserver(hide).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',hide);
  const schedule=()=>{const now=Date.now();if(now>=end){hide();return}setTimeout(()=>{hide();schedule()},Math.min(Math.max(1,(now<start?start:end)-now),2147483647))};
  schedule();
})();
